
import { Resource } from "src/app/core/jsonapi/resource";
import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { VehicleType } from "../../vehicles-types/_types/vehicle-type";
import { Worker } from "../../workers/_types/worker";
import { Company } from "../../companies/_types/company";
import { Business } from "../../business/_types/business";
import { VehicleBrand } from "./vehicleBrand";

export class VehicleBrandModel extends Resource {
    public override type = 'vehicleBrandsModels';

    @prop()
    @required()
    public name!: string;      

    @prop()    
    public vehicleBrandId!: string;    

    @propObject(VehicleBrand)
    public vehicleBrand: VehicleBrand = new VehicleBrand();

}